import React, {useCallback, useContext, useEffect, useState} from 'react'
import {HashRouter as Router, Route, Switch} from 'react-router-dom'
import {ThemeProvider} from 'styled-components'
import {UseWalletProvider} from 'use-wallet'
import DisclaimerModal from './components/DisclaimerModal'
import MobileMenu from './components/MobileMenu'
import TopBar from './components/TopBar'
import FarmsProvider from './contexts/Farms'
import ModalsProvider from './contexts/Modals'
import TransactionProvider from './contexts/Transactions'
import SushiProvider, {Context} from './contexts/SushiProvider'
import useModal from './hooks/useModal'
import theme from './theme'
import Farms from './views/Farms'
import Stake from './views/Stake'
import FarmsAdmin from "./views/Farms_admin/Farms_admin";

export const App: React.FC = () => {
    const [mobileMenu, setMobileMenu] = useState(false);

    const handleDismissMobileMenu = useCallback(() => {
        setMobileMenu(false)
    }, [setMobileMenu]);

    const handlePresentMobileMenu = useCallback(() => {
        setMobileMenu(true)
    }, [setMobileMenu]);


    return (
        <Providers>
            <Router>
                <div>
                    <TopBar onPresentMobileMenu={handlePresentMobileMenu}/>
                    <MobileMenu onDismiss={handleDismissMobileMenu} visible={mobileMenu}/>
                    <Switch>
                        <Route path="/" exact>
                            <Farms/>
                        </Route>
                        {/*<Route path="/farms" exact>*/}
                        {/*<Farms/>*/}
                        {/*</Route>*/}
                        <Route path="/staking">
                            <Stake/>
                        </Route>
                        <Route path="/admin">
                            <FarmsAdmin/>
                        </Route>
                    </Switch>
                </div>


            </Router>
            <Disclaimer/>
        </Providers>
    )
};

const Providers: React.FC = ({children}) => {
    return (
        <ThemeProvider theme={theme}>
            <UseWalletProvider
                chainId={1}
                connectors={{
                    walletconnect: {rpcUrl: 'https://mainnet.eth.aragon.network/'},
                }}
            >
                <SushiProvider>
                    <TransactionProvider>
                        <FarmsProvider>
                            <ModalsProvider>{children}</ModalsProvider>
                        </FarmsProvider>
                    </TransactionProvider>
                </SushiProvider>
            </UseWalletProvider>
        </ThemeProvider>
    )
};

const Disclaimer: React.FC = () => {
    const markSeen = useCallback(() => {
        localStorage.setItem('disclaimer', 'seen')
    }, [],);

    const [onPresentDisclaimerModal] = useModal(
        <DisclaimerModal onConfirm={markSeen}/>,
    );

    useEffect(() => {
        const seenDisclaimer = true; // localStorage.getItem('disclaimer')
        if (!seenDisclaimer) {
            onPresentDisclaimerModal()
        }
    }, []);

    return <div/>
};

